import axios from "axios";
import { BASE_URL } from "environment";
import { Store } from "_enums/enums";
import { SetLoadingStatus } from "./_shared/functions";
import { RouteNames } from "_route-names/route-names";
import store from "./config/configureStore"; // Import the store instance
import { userLogout } from "redux/user/userActions";

const instance = axios.create({
  baseURL: BASE_URL
});

// Flag to prevent multiple logout calls
let isLoggingOut = false;

instance.interceptors.request.use(
  (req) => {
    SetLoadingStatus(true);
    const token = localStorage.getItem(Store.token);
    // Respect a caller-supplied Authorization header (e.g. the scoped profile-completion
    // token used mid-signup) instead of clobbering it with the general session token.
    if (token && !req.headers["Authorization"]) {
      req.headers["Authorization"] = `Bearer ${token}`;
    }
    req.headers["content-type"] = "application/json";
    return req;
  },
  (error) => {
    SetLoadingStatus(false);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    SetLoadingStatus(false);
    return res;
  },
  async (error) => {
    SetLoadingStatus(false);
    if (error.response && error.response.status === 403) {
      const currentPath = window.location.hash || window.location.pathname;
      const isActivationPending = error.response.data?.reason === "ACTIVATION_PENDING";
      // Job Completion is a public page; skip redirect if token expires and show message instead.
      // Activation-pending is a soft, informational state (see SetupComplete) — background calls
      // like getJobs()/push-token sync racing ahead of that screen shouldn't nuke the session.
      if (!isActivationPending && ![RouteNames.JobCompletion, RouteNames.login].includes(currentPath) && !isLoggingOut) {
        isLoggingOut = true;
        try {
          await store.dispatch(userLogout());
        } finally {
          // Reset flag after a delay to allow for potential retries
          setTimeout(() => {
            isLoggingOut = false;
          }, 1000);
        }
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
